import * as S from './styles'

import LoadingButton from '@mui/lab/LoadingButton'
import { ButtonProps } from '@mui/material/Button'

interface IButtonProps extends ButtonProps {
  value?: string
  children?: any
  isLoading?: boolean
  className?: string
  component?: string
  onClick?: () => any
}

const Button = (props: IButtonProps) => {
  return props.isLoading ? (
    <S.LoadingButtonComponent
      loading
      variant="outlined"
      {...props}
      className={props.className}
    >
      {props.children || props.value || ''}
    </S.LoadingButtonComponent>
  ) : (
    <S.ButtonComponent
      variant="text"
      {...props}
      onClick={props.onClick}
      className={props.className}
    >
      {props.children || props.value}
    </S.ButtonComponent>
  )
}

export { Button }
export type { IButtonProps }
